import { render } from "./completed-course.vue?vue&type=template&id=11277e56"
import script from "./completed-course.vue?vue&type=script&lang=js"
export * from "./completed-course.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__